import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EnterpriseConfigurationDataAccessService } from './enterprise-configuration-data-access.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [EnterpriseConfigurationDataAccessService],
})
export class EnterpriseConfigurationModule {}
